/*
import React from "react";
import styled from "styled-components";
import { Header } from "./Header/Header";
import Footer from "../Viewer/Header/Footer";
import { Row } from "../Viewer/Header/Styles";
import { LogoutIcon, LogoutText } from "./Header/Styles";
import useViewer from "../../hooks/useViewer";
import useAlert from "../../hooks/useAlert";
import AuthService from "../../services/AuthService";
import moment from "moment";
import { navigate } from "@reach/router";
import { useSnackbar } from "notistack";
import { getErrorMessage } from "../../helpers/functions";

export default function TemporaryRoute({
  showSidebar = true,
  selectedItem,
  selectedSubItem,
  children,
}) {
  const role = localStorage.getItem("role");
  const { globalState, setGlobalState, userObject, setUserObject } =
    useViewer();
  const { showAlert, hideAlert } = useAlert();
  const { enqueueSnackbar } = useSnackbar();

  const { galleryView } = globalState?.livepage || {};

  const shouldRenderAgmHeader =
    globalState?.general?.eventTemplate === "AGM" && galleryView?.showHeader
      ? true
      : globalState?.general?.eventTemplate !== "AGM"
        ? true
        : false;

  const shouldRenderAgmFooter =
    globalState?.general?.eventTemplate === "AGM" && galleryView?.showFooter
      ? true
      : false;

  async function viewerLogout(viewerId, role) {
    try {
      const payload = {
        logoutTime: moment(new Date()).format("HH:mm"),
        role: role,
      };
      const eventId = userObject?.eventId;
      const response = await AuthService.viewerLogout(viewerId, payload);

      if (response?.status) {
        enqueueSnackbar("Logout successfully", { variant: "success" });
        localStorage.removeItem("auth_token");
        localStorage.removeItem("role");
        localStorage.removeItem("pollArray");
        localStorage.removeItem("dsnl_cookies_enabled");
        navigate(`/events/login?eventId=${eventId}`);
        setGlobalState({ customTab: [] });
        setUserObject({});
      }
    } catch (error) {
      enqueueSnackbar(getErrorMessage(error), { variant: "error" });
    } finally {
      hideAlert();
    }
  }

  const handleLogout = () => {
    showAlert({
      heading: "Logout?",
      desc: "Are you sure you want to logout?",
      primaryBtnText: "Logout",
      secondaryBtnText: "Cancel",
      clickSecondarybtn: () => hideAlert(),
      clickPrimaryBtn: () => viewerLogout(userObject?.viewerId, "eventViewer"),
      isOpen: true,
      onDialogClose: () => hideAlert(),
    });
  };

  return (
    <Layout
      image={globalState?.theme?.themeGeneral?.backgroundImage}
      bgColor={
        globalState?.theme?.themeGeneral?.bodyBackgroundColor || "#f8f9fa"
      }
    >
      {!shouldRenderAgmHeader && (
        <Row
          style={{
            justifyContent: "flex-end",
            marginTop: "34px",
            padding: "0 20px",
          }}
          onClick={handleLogout}
        >
          <LogoutIcon src={require("../../assets/images/logout.svg")} />
          <LogoutText>Sign Out</LogoutText>
        </Row>
      )}

      <Header
        showSidebar={showSidebar}
        selectedItem={selectedItem}
        selectedSubItem={selectedSubItem}
        showHeader={shouldRenderAgmHeader}
      >
        {children}
      </Header>

      {shouldRenderAgmFooter && <Footer />}
    </Layout>
  );
}

export const Layout = styled.div`
  min-height: 100vh;
  height: 100%;
  overflow-y: auto;
  scrollbar-width: none;

  background-color: ${({ bgColor }) => bgColor || "#ffffff"};
  background-image: ${({ image }) => (image ? `url(${image})` : "none")};
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: scroll;

  @media (min-width: 1024px) {
    background-attachment: ${({ image }) => (image ? "fixed" : "scroll")};
  }
`;

*/

import React from "react";
import styled from "styled-components";
import { Header } from "./Header/Header";
import Footer from "../Viewer/Header/Footer";
import { Row } from "../Viewer/Header/Styles";
import { LogoutIcon, LogoutText } from "./Header/Styles";
import useViewer from "../../hooks/useViewer";
import useAlert from "../../hooks/useAlert";
import AuthService from "../../services/AuthService";
import moment from "moment";
import { navigate } from "@reach/router";
import { useSnackbar } from "notistack";
import { getErrorMessage } from "../../helpers/functions";

export default function TemporaryRoute({
  showSidebar = true,
  selectedItem,
  selectedSubItem,
  children,
}) {
  const role = localStorage.getItem("role");
  const { globalState, setGlobalState, userObject, setUserObject } =
    useViewer();
  const { showAlert, hideAlert } = useAlert();
  const { enqueueSnackbar } = useSnackbar();

  const { galleryView } = globalState?.livepage || {};

  const shouldRenderAgmHeader =
    globalState?.general?.eventTemplate === "AGM" && galleryView?.showHeader
      ? true
      : globalState?.general?.eventTemplate !== "AGM"
        ? true
        : false;

  const shouldRenderAgmFooter =
    globalState?.general?.eventTemplate === "AGM" && galleryView?.showFooter
      ? true
      : false;

  async function viewerLogout(viewerId, role) {
    try {
      const payload = {
        logoutTime: moment(new Date()).format("HH:mm"),
        role: role,
      };
      const eventId = userObject?.eventId;
      const response = await AuthService.viewerLogout(viewerId, payload);

      if (response?.status) {
        enqueueSnackbar("Logout successfully", { variant: "success" });
        localStorage.removeItem("auth_token");
        localStorage.removeItem("role");
        localStorage.removeItem("pollArray");
        localStorage.removeItem("dsnl_cookies_enabled");
        navigate(`/events/login?eventId=${eventId}`);
        setGlobalState({ customTab: [] });
        setUserObject({});
      }
    } catch (error) {
      enqueueSnackbar(getErrorMessage(error), { variant: "error" });
    } finally {
      hideAlert();
    }
  }

  const handleLogout = () => {
    showAlert({
      heading: "Logout?",
      desc: "Are you sure you want to logout?",
      primaryBtnText: "Logout",
      secondaryBtnText: "Cancel",
      clickSecondarybtn: () => hideAlert(),
      clickPrimaryBtn: () => viewerLogout(userObject?.viewerId, "eventViewer"),
      isOpen: true,
      onDialogClose: () => hideAlert(),
    });
  };

  return (
    <Layout
      image={globalState?.theme?.themeGeneral?.backgroundImage}
      bgColor={
        globalState?.theme?.themeGeneral?.bodyBackgroundColor || "#f8f9fa"
      }
    >
      {!shouldRenderAgmHeader && (
        <Row
          style={{
            flex: "0 0 auto",
            justifyContent: "flex-end",
            marginTop: "34px",
            padding: "0 20px",
          }}
          onClick={handleLogout}
        >
          <LogoutIcon src={require("../../assets/images/logout.svg")} />
          <LogoutText>Sign Out</LogoutText>
        </Row>
      )}

      <Header
        showSidebar={showSidebar}
        selectedItem={selectedItem}
        selectedSubItem={selectedSubItem}
        showHeader={shouldRenderAgmHeader}
      >
        {children}
      </Header>

      {shouldRenderAgmFooter && <Footer />}
    </Layout>
  );
}

export const Layout = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  background-color: ${({ bgColor }) => bgColor || "#ffffff"};
  background-image: ${({ image }) => (image ? `url(${image})` : "none")};
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: scroll;

  @media (min-width: 1024px) {
    background-attachment: ${({ image }) => (image ? "fixed" : "scroll")};
  }
`;
